import React from 'react'
import '../guia-de-estilos.css'
import { FaEdit, FaTimes, FaUserCheck, FaUserShield } from "react-icons/fa";

const Tablas = () => {
  return (
    <div className='container-fluid d-flex justify-content-center pb-5 border-bottom border-3'>
      <div className='container p-0 mt-3'>
        <div className='container-lg p-0'>
          <div className='py-3'>
            <p className='short-title font-semibold text-premium-blue mt-4'>Tablas</p>
          </div>
          <div className='row mt-3 row-gap-3 text-premium-blue'>
            <div className='col-12 col-xl-6'>
              <div className="main-panel">
                <div className="main-panel-name d-flex">
                  <FaUserCheck className="fs-5 align-self-center" />
                  <p className="fw-bold ps-2 m-0 align-self-center">Usuarios</p>
                </div>
                <div className="main-panel-body">
                  <div className='table-responsive'>
                    <div className="panel-table">
                      <div className='colum-left'>
                        <input type="text" className='searchInput' id="searchInput" placeholder="Buscar..." />
                        <button className='btnn'>Buscar</button>
                      </div>
                      <div className='colum-rigth'>
                        <button className="btnn">
                          Agregar Usuario
                        </button>
                      </div>
                    </div>
                    <table className='table table-preve' id='tableToSearch'>
                      <thead>
                        <tr>
                          <th>Name</th>
                          <th>Email</th>
                          <td className='accions'>Acciones</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Lalo</td>
                          <td>evelez@fabricadesoluciones.com</td>
                          <td>
                          <FaEdit className='editButton' onClick={() =>{ }}/>
                          <FaTimes className='deleteButton' onClick={() =>{ }}/>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className='col-12 col-xl-6'>
              <div className="main-panel">
                <div className="main-panel-name d-flex">
                  <FaUserShield className="fs-5 align-self-center" />
                  <p className="fw-bold ps-2 m-0 align-self-center">Permisos</p>
                </div>
                <div className="main-panel-body"> 
                  <div className='table-responsive'>
                    <div className="panel-table">
                      <div className='colum-left'>
                        <input type="text" className='searchInput' id="searchInput" placeholder="Buscar..." />
                        <button className='btnn'>Buscar</button>
                      </div>
                      <div className='colum-rigth'>
                        <button className="btnn">
                          Agregar Permisos
                        </button>
                      </div>
                    </div>
                    <table className='table table-preve' id='tableToSearch'>
                      <thead>
                        <tr>
                          <th>Usuario</th>
                          <td className='accions'>Acciones</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Lalo</td>
                          <td>
                            <FaEdit className='editButton' onClick={() =>{ }}/>
                            <FaTimes className='deleteButton' onClick={() =>{ }}/>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div> 
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Tablas